import { rem } from 'polished';
import styled from 'styled-components';

import { IStyledWrapperProps } from './BookingRequestStage.types';

export const StyledWrapper = styled.div<IStyledWrapperProps>`
  display: flex;
  padding: ${rem('4px')} ${rem('12px')};
  align-items: center;
  gap: ${rem('4px')};
  border: ${rem('1px')} solid;
  border-radius: ${rem('46px')};
  font-size: ${rem('12px')};
  font-weight: 600;
  border-color: ${({ theme }) => theme.colors.cross.silverFox};
  color: ${({ theme }) => theme.colors.cross.silverFox};

  ${({ isAccepted, theme }) =>
    isAccepted &&
    `
    border-color: ${theme.colors.cross.greenMint};
    color: ${theme.colors.cross.greenMint};
  `}

  ${({ isRejected, theme }) =>
    isRejected &&
    `
    border-color: ${theme.colors.cross.red};
    color: ${theme.colors.cross.red};
  `}

  ${({ isPending, theme }) =>
    isPending &&
    `
    border-color: ${theme.colors.cross.grayson};
    color: ${theme.colors.cross.grayson};
  `}
`;
